// Domain
import {
  CustomerOverviewEntity,
} from '@/modules/home-dashboard/customer-overview/domain/entities/customer-overview-entity';

export default class CustomerOverviewState {
  loaded = false;

  is_loading = false;

  item: CustomerOverviewEntity = {
    customer_id: '',
    is_active: false,
    onboarding_completed: true,
    onboarding_completed_at: '',
    has_any_product_contracted: false,
    personal_information_overview: {
      person_id: '',
      name: '',
      last_name: '',
      second_last_name: '',
    },
    pocket_investment_product_overview: {
      pocket_investment_product_id: '',
      contracted: false,
      contracting_status: '',
      available_to_contract: false,
    },
    wealth_investment_product_overview: {
      wealth_investment_product_id: '',
      contracted: false,
      contracting_status: '',
      available_to_contract: false,
      first_interaction_with_dashboard: false,
      moderate_fund_type_overview: {
        moderate_investment_product_fund_type_id: '',
        contracted: false,
      },
      wealth_contract_overview: {
        allianz_account_id: '',
        policy_number: '',
        folio: '',
        was_issued: false,
      },
    },
    investment_suggestion_overview: {
      investment_suggestion_analytic_id: '',
      must_be_shown: false,
    },
    investor_profile_overview: {
      investor_profile_id: '',
      is_completed: false,
      is_incompleted: false,
      update_required: false,
      years_without_updating: 0,
      recommended_investment_product: null,
    },
    referrers_overview: {
      sent: 0,
      completed: 0,
    },
    goals_overview: {
      goals_completed: false,
      active_goals: 0,
      active_goals_with_tracking: 0,
      active_goals_without_tracking: 0,
      inactive_goals: 0,
    },
  };
}
